/**
 * @module plugins/date-fns
 * @description This plugin integrates the date-fns library into Nuxt.
 * @param {Object} nuxtApp - The Nuxt app instance.
 * @returns {void} This function does not have a return value.
 */

import { format } from 'date-fns'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('dateFormat', format)
})